import { api } from "../axios"

export const generateKeySdk = async (name: string) => {
  return api.post('/sdk/keys/generate', { name });
}

export const deleteKeySdk = async (key: string) => {
  return api.delete('/sdk/keys/delete', { data: { key } });
}

export const getListKeySdk = async () => {
  return api.get('/sdk/keys');
}